import React, { Component, ReactNode } from 'react';

class AiModelTrainingParameterComponent extends Component<Props> {
  public render() {
    const { input, title, description } = this.props;
    return (
      <div className={'flex w-full gap-y-1 gap-x-40 items-center'}>
        <div className='flex w-1/2'>
          <span className={'ml-[3px] items-center text-md text-[#607080] font-normal'}>
            <p className={'text-primary font-lg w-[150px] font-semibold'}>{title}</p>
            <p className={'flex w-full'}>{description}</p>
          </span>
        </div>
        <div className='flex w-full items-center'>{input}</div>
      </div>
    );
  }
}

interface Props {
  title: string;
  description: string;
  input: ReactNode;
}

export default AiModelTrainingParameterComponent;
